import { FaSearch } from "react-icons/fa";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 85px 20px 20px 20px;
    
    @media (max-width: 600px) {
        padding: 65px 10px 10px 10px;
    }
`;

export const SearchContainer = styled.div`
    position: relative;
    width: 100%;
    margin-bottom: 30px;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 10px 40px 10px 30px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const SearchIcon = styled(FaSearch)`
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    color: #aaa;
`;

export const ClearButton = styled.button`
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #aaa;
    font-size: 16px;
`;

export const MovieList = styled.ul`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    list-style: none;
    padding: 0;
    width: 100%;
    gap: 10px;

    @media (max-width: 1600px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: 1000px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 800px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 300px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const MovieItem = styled.li`
    padding: 10px;
    border-bottom: 1px solid #eee;
    color: #555;
`;

export const LoadMoreButton = styled.button`
    background: #404040;
    border: none;
    border-radius: 50px;
    color: #fff;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 700;
    padding: 10px 40px;
    margin: 50px 0;
    transition: all .3s ease;

    &:hover {
        background: #505050;
    }
`;